import { render, staticRenderFns } from "./MyCoursesPage.vue?vue&type=template&id=72273c18&scoped=true&"
import script from "./MyCoursesPage.vue?vue&type=script&lang=js&"
export * from "./MyCoursesPage.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesPage.vue?vue&type=style&index=0&id=72273c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72273c18",
  null
  
)

export default component.exports